import { Calculator, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Navigation from "@/components/Navigation";
import QuoteCalculator from "@/components/QuoteCalculator";

export default function QuotePage() {
  return (
    <div className="min-h-screen bg-background pb-20 md:pb-0">
      <Navigation />
      
      {/* Header */}
      <header className="border-b border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Link to="/purchasing">
              <Button variant="ghost" size="icon" className="h-8 w-8">
                <ArrowLeft className="h-4 w-4" />
              </Button>
            </Link>
            <div>
              <div className="flex items-center gap-2">
                <Calculator className="h-6 w-6 text-primary" />
                <h1 className="font-heading text-2xl font-bold uppercase tracking-tight" data-testid="quote-page-title">
                  Räkna Offert
                </h1>
              </div>
              <p className="text-sm text-muted-foreground mt-1">
                Beräkna offerter med produkter från lagret
              </p>
            </div>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-6">
        <QuoteCalculator />
      </main>
    </div>
  );
}
